<script setup lang="ts">
import { watch } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useUiStore } from '@/stores/ui';
import { useReviewStore } from '@/stores/review';

const auth = useAuthStore();
const ui = useUiStore();
const review = useReviewStore();
const close = () => (ui.sidebarMobileOpen = false);

// badge met open inzendingen voor goedkeurders/admins (poll elke 60s)
watch(
  () => auth.isApprover,
  (is) => (is ? review.startPolling() : review.stopPolling()),
  { immediate: true },
);
</script>

<template>
  <aside
    class="kl-sidebar"
    :class="{ collapsed: ui.sidebarCollapsed, 'mobile-open': ui.sidebarMobileOpen }"
    aria-label="Hoofdnavigatie"
  >
    <nav class="nav flex-column py-2">
      <div class="kl-sidebar-heading">Configurator</div>
      <router-link class="nav-link" to="/products" title="Producten" @click="close"
        ><i class="bi bi-diagram-3"></i><span>Producten</span></router-link
      >
      <router-link class="nav-link" to="/products/new" title="Nieuw product" @click="close"
        ><i class="bi bi-plus-square"></i><span>Nieuw product</span></router-link
      >
      <router-link class="nav-link" to="/import" title="Importeren" @click="close"
        ><i class="bi bi-clipboard-data"></i><span>Importeren (plakken)</span></router-link
      >
      <router-link class="nav-link" to="/unit4/load" title="Laden uit Unit4" @click="close"
        ><i class="bi bi-cloud-download"></i><span>Laden uit Unit4</span></router-link
      >
      <router-link class="nav-link" to="/feedback" title="Feedback" @click="close"
        ><i class="bi bi-megaphone"></i><span>Feedback</span></router-link
      >
      <template v-if="auth.isApprover">
        <div class="kl-sidebar-heading mt-2">Goedkeuren</div>
        <router-link class="nav-link" to="/review" title="Beoordelen" @click="close"
          ><i class="bi bi-clipboard-check"></i><span>Beoordelen</span
          ><span
            v-if="review.openCount"
            class="badge rounded-pill text-bg-danger kl-nav-badge"
            :aria-label="`${review.openCount} open inzendingen`"
            >{{ review.openCount > 99 ? '99+' : review.openCount }}</span
          ></router-link
        >
        <router-link
          v-if="!auth.isAdmin"
          class="nav-link"
          to="/admin/templates"
          title="Sjablonen"
          @click="close"
          ><i class="bi bi-copy"></i><span>Sjablonen</span></router-link
        >
        <router-link
          v-if="!auth.isAdmin"
          class="nav-link"
          to="/admin/product-codes"
          title="Productcodes"
          @click="close"
          ><i class="bi bi-123"></i><span>Productcodes</span></router-link
        >
        <router-link
          v-if="!auth.isAdmin"
          class="nav-link"
          to="/admin/sizing"
          title="Actuator-sizing"
          @click="close"
          ><i class="bi bi-cpu"></i><span>Actuator-sizing</span></router-link
        >
      </template>
      <template v-if="auth.isAdmin">
        <div class="kl-sidebar-heading mt-2">Beheer</div>
        <router-link class="nav-link" to="/admin/users" title="Gebruikers" @click="close"
          ><i class="bi bi-people"></i><span>Gebruikers</span></router-link
        >
        <router-link class="nav-link" to="/admin/templates" title="Sjablonen" @click="close"
          ><i class="bi bi-copy"></i><span>Sjablonen</span></router-link
        >
        <router-link class="nav-link" to="/admin/product-codes" title="Productcodes" @click="close"
          ><i class="bi bi-123"></i><span>Productcodes</span></router-link
        >
        <router-link class="nav-link" to="/admin/sizing" title="Actuator-sizing" @click="close"
          ><i class="bi bi-cpu"></i><span>Actuator-sizing</span></router-link
        >
        <router-link class="nav-link" to="/admin/settings" title="Instellingen" @click="close"
          ><i class="bi bi-gear"></i><span>Instellingen</span></router-link
        >
        <router-link class="nav-link" to="/admin/sync-log" title="Sync-historie" @click="close"
          ><i class="bi bi-clock-history"></i><span>Sync-historie</span></router-link
        >
        <router-link class="nav-link" to="/admin/lookup-jobs" title="AI-zoekopdrachten" @click="close"
          ><i class="bi bi-robot"></i><span>AI-zoekopdrachten</span></router-link
        >
      </template>
    </nav>
  </aside>
  <div v-if="ui.sidebarMobileOpen" class="modal-backdrop fade show d-lg-none" @click="close"></div>
</template>
